function replaceText(find) {
	
	var doc = document.implementation.createHTMLDocument();
	var div = doc.createElement('div')
	
	replaceArray.forEach(function(item) {
		item['ezeket-keresd'].forEach(function(pattern) {
			if (pattern[0] != "/" && pattern[pattern.length - 1] != "/")
				 pattern = '(.?)('+ pattern.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") +')(.?)';
			else pattern = pattern.substring(1, pattern.length - 1);
			
			while (found = new RegExp(pattern, item['modifiers'] || "gim").exec(find)) {
				var tipData = {
					  key			: item.key
					, eredeti		: find.substr(found.index + 1, found[2].length)
					, cime			: item.cime
					, ezUgorjonFel	: item ['ez-ugorjon-fel']
				};
				if (item.hivatkozas && item.hivatkozas.length > 0) {
					tipData['hivatkozas']	= item.hivatkozas;
				}
				find = find.substr(0, found.index + 1) +'###'+ window.btoa(unescape(encodeURIComponent(JSON.stringify(tipData)))) +'###'+ find.substr(found.index + 1 + found[2].length);
			}
		});
	});
	
	found = new RegExp(/###([^#]+)###/gim).exec(find);
	while (found = new RegExp(/###([^#]+)###/gim).exec(find)) {
		var tipData = JSON.parse(decodeURIComponent(escape(window.atob(found[1]))));
		var tipTag = '<a\
			data-key="'+ tipData.key +'"\
			style="font-weight:600;text-decoration:none;color:#007a87;'+ (tipData.hivatkozas ? 'cursor:pointer;"\
			href="'+ tipData.hivatkozas : '') +'"\
			class="tip"\
			target="_blank">'+ tipData.eredeti +'</a>';
		div.innerHTML = tipTag;
		div.childNodes[0].setAttribute('title', '<h3 style="color: #fff;margin-top: 0px;">'+ tipData.cime +'</h3>'+ tipData.ezUgorjonFel);
		tipTag = div.innerHTML;
		find = find.substr(0, found.index) + tipTag + find.substr(found.index + 6 + found[1].length);
	}
	
	return find;
	
}

$(document).ready(function(){
	setTimeout(function(){

		for (key in replaceArray) {
			item = replaceArray [key];
			replaceArray [key] ['key'] = key;
			item ['ez-ugorjon-fel'] = item ['ez-ugorjon-fel'].replace(/(https?:\/\/[^\s]+)/gim, '<br><img src="$1" style="max-width: 600px; max-height: 600px; display: block; margin: auto;" />');
			item ['ez-ugorjon-fel'] = item ['ez-ugorjon-fel'].replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
		}

		$('.description .ui-tabs-panel').each(function(k, elem){
			$(elem).html(replaceText( $(elem).html() ));
		});

		tippy('.tip', {
			animation: 'scale',
			duration: 100,
			arrow: true,
		});

		$('a[href="#"]').css('cursor', 'default').attr('href', 'javascript:0;');

	}, 1000);

});